import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import s from './FindDistributors.module.css';
import searchIcon from '../../assets/img/Header/ei_search.png';
import DistributorsTree from './DistributorsTree/DistributorsTree';
import {useTranslation} from 'react-i18next';
import {useVerifyPaymentMutation} from '../../redux/DepotSlice/depotCashierApi';
import {toast} from 'react-toastify';
import {UserClient} from '../../types/TypesUser';
import {useLazySearchClientByContractQuery} from '../../redux/userClientsApi';
import {handleApiCall} from '../../assets/utils/utils';
import {useDebouncedCallback} from 'use-debounce';
import {Link} from 'react-router-dom';
import {monthNow} from '../../assets/utils/dateUtils';

type Props = {
	componentType?: 'registered';
	client: UserClient | null;
	setClient: Dispatch<SetStateAction<UserClient | null>>;
	status?: any;
};
const FindDistributorsComponent: React.FC<Props> = ({
	client,
	setClient,
	status,
	componentType,
}) => {
	const {t} = useTranslation();
	const month = monthNow();
	const [distributorsTree, setDistributorsTree] = useState(false);
	const [contract, setContract] = useState('');
	const [money, setMoney] = useState<string>('');
	const [errorNoMoney, setErrorNoMoney] = useState<string>('');
	const [infoActivityMonthText, setInfoActivityMonthText] = useState<
		string | null
	>(null);
	const [infoActivityContractText, setInfoActivityContractText] =
		useState<boolean>(false);
	const [searchClient, {data: findedClient}] =
		useLazySearchClientByContractQuery();

	const [verifyPayment] = useVerifyPaymentMutation();

	useEffect(() => {
		if (findedClient) {
			if (!findedClient.activedstr) {
				toast.error(
					t('Клієнт з таким номером контрактом вже втратив контракт'),
				);
				return;
			}
			if (findedClient.in_tree) {
				toast.success(t('Клієнт в дереві'));
				setInfoActivityContractText(false);
			} else {
				toast.error(t('Контракт не в вашій структурі'));
				setClient(null);
				setMoney('');
				setErrorNoMoney('');
				return;
			}
			setInfoActivityContractText(!findedClient.activedstr);
			if (findedClient.activity_month === 0) {
				setInfoActivityMonthText(t('Клієнт не активний'));
			} else {
				setInfoActivityMonthText(
					`${t('Клієнт активний на')} ${findedClient.activity_month} ${t('балів')}`,
				);
			}
			
			// Теперь clients/find-activity возвращает полный формат UserClient
			const client: UserClient = {
				name: findedClient.name,
				client_id: findedClient.client_id,
				activedstr: findedClient.activedstr,
				contract: findedClient.contract || '',
				level: findedClient.level || 0,
				parent_id: findedClient.parent_id || null,
				position: findedClient.position || null,
				qlfc: findedClient.qlfc || '',
				user_points: findedClient.user_points || '',
				money: findedClient.money,
				type: findedClient.type, // тип клиента (loyal/ordinary)
			};

			setClient(client);
		}
	}, [findedClient]);

	const handleVerifyPaymentHandler = async (id: number) => {
		await handleApiCall({
			apiCall: () => verifyPayment(id.toString()),
			onSuccess: (data) => {
				if (data.approve) {
					setMoney(data.money);
					setErrorNoMoney('');
					// обновляем клиента тут, а не отдельным эффектом
					setClient((prev) => (prev ? {...prev, money: data.money} : prev));
					toast.success(data.message.textmsg);
				}
			},
			onError: (error) => {
				setErrorNoMoney(error);
			},
		});
	};
	const handleFindUser = async () => {
		if (contract?.length > 5) {
			searchClient({
				month,
				contract: contract,
			});
		}
	};
	const handleChangeClient = useDebouncedCallback((value: string) => {
		if (value.length > 4) {
			searchClient({month, contract: value});
		}
	}, 500);
	const handleChangeUser = (client: UserClient) => {
		setClient(client);
		setContract(client.contract);
		setInfoActivityContractText(false);
		setDistributorsTree(false);
	};
	useEffect(() => {
		if (client?.client_id && !componentType) {
			setMoney('');
			setErrorNoMoney('');
			handleVerifyPaymentHandler(client.client_id).catch();
		}
	}, [client?.client_id]);

	useEffect(() => {
		if (!client) {
			// Сбрасываем поле контракта когда клиент становится null
			setContract('');
			setMoney('');
			setErrorNoMoney('');
			setInfoActivityMonthText(null);
			setInfoActivityContractText(false);
		}
	}, [client]);
	return (
		<div>
			<div className={s.clientInfo_flex}>
				<div className={`${s.input} ${s.findDistributorsInput}`}>
					<input
						value={contract}
						//onBlur={handleFindUser}
						onChange={(e) => {
							setContract(e.currentTarget.value);
							handleChangeClient(e.currentTarget.value);
						}}
						placeholder={t('Контракт партнера')}
					/>
					<button
						onClick={handleFindUser}
						type={'button'}
						className={s.findDistributorsLupa}
					>
						<img src={searchIcon} alt="find-icon" />
					</button>
					{status && status.contract && (
						<span className={s.error}>{status.contract}</span>
					)}
				</div>
				{!componentType && <></>}
				{client && client.name !== '' ? (
					<div className={s.clientSelectLink}>
						<button
							className={s.text_myClients}
							type={'button'}
							onClick={() => setDistributorsTree(true)}
						>
							{client.name}
						</button>
					</div>
				) : (
					<>
						<div className={s.clientSelectLink}>
							{t('або')}
							<button
								className={s.text_myClients}
								type={'button'}
								onClick={() => setDistributorsTree(true)}
							>
								{t('Мої клієнти')}
							</button>
						</div>
					</>
				)}
				<div>
					{distributorsTree && (
						<DistributorsTree
							handleChangeUser={handleChangeUser}
							closePopup={() => setDistributorsTree(false)}
						/>
					)}
				</div>
			</div>
			{!componentType && (
				<>
					<div className={s.error}>{errorNoMoney !== '' && errorNoMoney}</div>
					{infoActivityContractText && (
						<div className={s.error}>
							{t('Клієнт з таким номером контрактом вже втратив контракт')}
							<Link to={'/registration_new_client'}>
								<span className={s.link}>{t('Зареєструвати заново')}</span>
							</Link>
						</div>
					)}
					{money !== '' && errorNoMoney === '' && (
						<div className={s.bonusCount}>
							{t('На бонусному рахунку клієнта')} <span>{money} </span>
						</div>
					)}
					{infoActivityMonthText && (
						<div className={s.bonusCount}>{infoActivityMonthText}</div>
					)}
				</>
			)}
		</div>
	);
};

export default FindDistributorsComponent;
